import tempCheck from "./tempCheck";
tempCheck.install = function(Vue) {
  Vue.component(tempCheck.name, tempCheck);
};
export default tempCheck;
